import permissions from '../constants/permissions';

/**
 * Service module for common activity services/utilities.
 */
angular
  .module('services.activity', ['services.bulkrestoredata', 'services.util', 'services.permissions', 'sbsf.enums'])
  /**
   * A factory with common activity utilities.
   */
  .factory('activityUtils', [
    '$state',
    'batchUtils',
    'VIEW_STATES',
    'permissionService',
    'BulkRestoreType',
    'JOB_TYPE',
    function ($state, batchUtils, VIEW_STATES, permissionService, BulkRestoreType, JOB_TYPE) {
      class ActivityUtils {
        /**
         * Redirect the view to the batch detail view.
         */
        static goToBatch(batch) {
          var params = {
            batchId: batch.batchId
          };

          batchUtils.currentBatch = batch;

          // go load the appropriate view depending on the batch type
          if (batchUtils.isBatchExportType(batch)) {
            $state.go(VIEW_STATES.BATCH_EXPORT, params);
          } else if (batch.type === 'OBJECT_RESTORE') {
            $state.go(VIEW_STATES.BATCH_OBJECT_RESTORE, params);
          } else if (batchUtils.isBatchBulkRestoreType(batch)) {
            $state.go(VIEW_STATES.BATCH_BULK_RESTORE, params);
          } else if (batch.type === 'BULK_RESTORE_CSV_VERIFICATION') {
            const parentJobType = batchUtils.getParentJobTypeForCsvVerification(batch.bulkRestoreCsvVerificationData);
            const stateToGo = batchUtils.getStateToGoAfterCsvVerification(parentJobType);

            let permission = null;
            if (stateToGo === JOB_TYPE.BULK_RESTORE) {
              permission = permissions.RESTORE;
            }
            if (stateToGo === JOB_TYPE.EXPORT) {
              permission = permissions.EXPORT;
            }

            permissionService.hasPermission(permission).then((hasPermission) => {
              if (hasPermission) {
                $state.go(stateToGo, {
                  bulkRestoreType: BulkRestoreType.VERIFIED_CSV,
                  batch: batch
                });
              }
            });
          } else if (batch.type === 'METADATA_COMPARE') {
            params = {
              batchId: batch.batchId
            };

            $state.go(VIEW_STATES.METADATA_COMPARE_RESULTS, params);
          } else if (batch.type === 'DOWNLOAD_BATCH_OUTPUT') {
            // use the downloaded batchId and not the Id of the batch itself
            params = {
              batchId: batch.batchOutputDownloadedId
            };

            batchUtils.currentBatch = batch.batchOutputDownloadedId;
            $state.go(VIEW_STATES.BATCH_EXPORT, params);
          } else if (batch.type === 'METADATA_RESTORE') {
            params = {
              batchId: batch.batchId
            };
            $state.go(VIEW_STATES.BATCH_METADATA_RESTORE, params);
          } else if (batch.type.startsWith('GDPR')) {
            params = {
              batchId: batch.batchId
            };
            $state.go(VIEW_STATES.BATCH_GDPR_REQUEST, params);
          } else {
            $state.go(VIEW_STATES.BATCH_HOME, params);
          }
        }

        static getBatchViewState(batch) {
          if (batchUtils.isBatchExportType(batch)) {
            return VIEW_STATES.BATCH_EXPORT;
          } else if (batch.type === 'OBJECT_RESTORE') {
            return VIEW_STATES.BATCH_OBJECT_RESTORE;
          } else if (batchUtils.isBatchBulkRestoreType(batch)) {
            return VIEW_STATES.BATCH_BULK_RESTORE;
          } else if (batch.type === 'BULK_RESTORE_CSV_VERIFICATION') {
            const parentJobType = batchUtils.getParentJobTypeForCsvVerification(batch.bulkRestoreCsvVerificationData);
            return batchUtils.getStateToGoAfterCsvVerification(parentJobType);
          } else if (batch.type === 'METADATA_COMPARE') {
            return VIEW_STATES.METADATA_COMPARE_RESULTS;
          } else if (batch.type === 'DOWNLOAD_BATCH_OUTPUT') {
            return VIEW_STATES.BATCH_EXPORT;
          } else if (batch.type === 'METADATA_RESTORE') {
            return VIEW_STATES.BATCH_METADATA_RESTORE;
          } else if (batch.type.startsWith('GDPR')) {
            return VIEW_STATES.BATCH_GDPR_REQUEST;
          } else {
            return VIEW_STATES.BATCH_HOME;
          }
        }
      }
      return ActivityUtils;
    }
  ]);
